import { CREDENTIAL_LABEL_SOURCE_MANUAL } from '@shared/schema/credentialLabelSource.js';
import { hasOwn } from '@shared/utils/hasOwn.js';

export const resolveCredentialSaveMeta = ({ credentialMeta = {}, currentSecrets = {}, nextSecrets = {}, changedKey } = {}) => {
  const hasNextLabel = hasOwn(nextSecrets, 'label');
  const currentLabel = credentialMeta?.label ?? currentSecrets?.label;
  const labelChanged = changedKey === 'label' || (hasNextLabel && nextSecrets?.label !== currentLabel);
  const nextMeta = { ...credentialMeta, environmentId: nextSecrets?.environmentId };

  if (labelChanged) {
    nextMeta.label = nextSecrets?.label;
    nextMeta.labelSource = CREDENTIAL_LABEL_SOURCE_MANUAL;
  }

  return { meta: nextMeta, labelChanged };
};
